<template>
  <v-container class="text-center">
    <v-row>
      <v-col v-if="registStatus">
        受講登録が完了しました。
      </v-col>
      <v-col v-else>
        すでに登録されている講座です。
      </v-col>
    </v-row>
    <v-row>
      <v-col justify="center">
        <v-btn small color="error" @click="moveToMyapage">
          マイページへ移動
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import repository from '@/store/repository'

export default {
  props: {
    registStatus: {
      type: Boolean,
      required: true
    }
  },
  async created () {
    this.$store.commit('deleteRegistCourseId')
    repository.setRegistCourseId(null)
  },
  methods: {
    moveToMyapage: function () {
      this.$router.push({ path: '/' })
    }
  }
}
</script>
